<!-- bill print template -->
<div class="container" id="billPreview" style="display: none;">
  <table width="100%" border="0" cellpadding="0" align="center">
    <tr style="border-bottom: 4px solid var(--primary-color);">
      <td style="width: 40%;padding-bottom: 5px;">
        <div style="font-weight: bold; font-size: 15px;margin-bottom: 10px;">Bill -
          {{billPrintDetails?.selectedBill?.billno}}
        </div>
        <div *ngIf="billPrintDetails?.selectedBill?.billno">
          <ngx-barcode [bc-element-type]="elementType" [bc-value]="billPrintDetails?.selectedBill?.billno"
            [bc-format]="format" [bc-line-color]="lineColor" [bc-width]="width" [bc-height]="height"
            [bc-display-value]="displayValue" [bc-font-options]="fontOptions" [bc-font]="font"
            [bc-text-align]="textAlign" [bc-text-position]="textPosition" [bc-text-margin]="textMargin"
            [bc-font-size]="fontSize" [bc-background]="background" [bc-margin]="margin" [bc-margin-top]="marginTop"
            [bc-margin-bottom]="marginBottom" [bc-margin-left]="marginLeft" [bc-margin-right]="marginRight">
          </ngx-barcode>
        </div>
      </td>
      <td style="width: 25%; height: 50px; padding-bottom: 10px" *ngIf="app && app.appLogo">
        <img style="width: auto; height: auto; max-width: 100px; max-height: 50px" [src]="app.appLogo" alt="logo" />
      </td>
      <td style="padding-bottom: 5px;width: 35%;">
        <div style="font-weight: bold; font-size: 12px;">{{app?.organizationData?.name}}</div>
        <div style="font-size: 8px;color: #888;">{{companyInfo?.address || ''}}</div>
        <div style="font-size: 8px;color: #888;">{{companyInfo?.state || ''}} {{companyInfo?.state ? ',' : ''}}
          {{companyInfo?.city || ''}} {{companyInfo?.city ? ',' : ''}} {{companyInfo?.country || ''}}
          {{companyInfo?.country && companyInfo?.zip ? ',' : ''}} {{companyInfo?.zip || ''}}</div>
        <div style="font-size: 8px;color: #888;">{{companyInfo?.phone || ''}}</div>
        <div style="font-size: 8px;color: #888;">{{companyInfo?.emailId || ''}}</div>
      </td>
    </tr>
    <tr>
      <td colspan="3">
        <table width="100%" border="0" cellpadding="0" style="border-collapse: collapse;">
          <tr>
            <td style="padding: 9px 9px 9px 0; border-bottom: 1px solid #ddd; vertical-align: top;" [attr.colspan]="1"
              [ngStyle]="{ width:  '50%'} ">
              <div style="font-weight: bold; font-size: 13px; margin-bottom: 9px;">Billing:</div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[0]?.IsPrint">
                {{billPrintDetails?.selectedBill?.name}}</div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[1]?.IsPrint">
                {{billPrintDetails?.ordersVendorAddrNew}} <span
                  *ngIf="billPrintDetails?.ordersVendorAddrNew !== ''">,</span>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[2]?.IsPrint">
                {{billPrintDetails?.ordersVendorCityNew}}<span *ngIf="billPrintDetails?.ordersVendorCityNew !== ''">,
                </span>
                {{billPrintDetails?.ordersVendorStateNew}}
                <span *ngIf="billPrintDetails?.ordersVendorStateNew !== ''">, </span>
                {{billPrintDetails?.ordersVendorCountryNew}}
                <span *ngIf="billPrintDetails?.ordersVendorCountryNew !== ''">, </span>
                {{billPrintDetails?.ordersVendorZipcodeNew}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[3]?.IsPrint">
                {{billPrintDetails?.savedBill?.contact?.firstName}}</div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_billaddress  && billTemplate.labels_billaddress[4]?.IsPrint">
                {{billPrintDetails?.ordersVendorPhoneNew}}</div>

            </td>
            <td style="border-bottom: 1px solid #ddd; border-left: 1px solid #ddd;
                            padding: 9px 0 9px 9px; vertical-align: top; width: 50%;">
              <div style="font-weight: bold; font-size: 12px; margin-bottom: 9px;">Shipping:</div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[0]?.IsPrint">
                {{app?.user?.organizationName}}</div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[1]?.IsPrint">
                {{billPrintDetails?.savedBill?.warehouse?.address?.streetAddress1 ?
                billPrintDetails?.savedBill?.warehouse?.address?.streetAddress1 :
                (billPrintDetails?.savedBill?.warehouse?.address?.streetAddress2 ?
                billPrintDetails?.savedBill?.warehouse?.address?.streetAddress2 :
                null)}} <span
                  *ngIf="billPrintDetails?.savedBill?.warehouse?.address?.city && (billPrintDetails?.savedBill?.warehouse?.address?.streetAddress1 || billPrintDetails?.savedBill?.warehouse?.address?.streetAddress2)">,</span>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[2]?.IsPrint">
                {{billPrintDetails?.savedBill?.warehouse?.address?.city ?
                billPrintDetails?.savedBill?.warehouse?.address?.city?.name : null}}<span
                  *ngIf="billPrintDetails?.savedBill?.warehouse?.address?.state">,</span>
                {{billPrintDetails?.savedBill?.warehouse?.address?.state ?
                billPrintDetails?.savedBill?.warehouse?.address?.state?.name
                : null}}<span *ngIf="billPrintDetails?.savedBill?.warehouse?.address?.country">,</span>
                {{billPrintDetails?.savedBill?.warehouse?.address?.country ?
                billPrintDetails?.savedBill?.warehouse?.address?.country?.name :
                null}}
                <span *ngIf="billPrintDetails?.savedBill?.warehouse?.address?.zipCode">,</span>
                {{billPrintDetails?.savedBill?.warehouse?.address?.zipCode
                ? billPrintDetails?.savedBill?.warehouse?.address?.zipCode : null}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[3]?.IsPrint">
                {{billPrintDetails?.savedBill?.warehouse?.contactPersonName}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;margin-left: 2px;"
                *ngIf="billTemplate && billTemplate.labels_shipaddress  && billTemplate.labels_shipaddress[4]?.IsPrint">
                {{billPrintDetails?.savedBill?.warehouse?.phoneNo}}
              </div>


            </td>
          </tr>
          <tr>
            <td style="padding: 9px 9px 9px 0; border-bottom: 1px solid #ddd; vertical-align: top;
                          width: 50%;">
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[0]?.IsPrint">
                <div>Bill No.: {{billPrintDetails?.selectedBill?.billno}}
                </div>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[0]?.isChecked">
                {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[0]?.labelname}}:
                {{billPrintDetails?.selectedBill?.billDate | date: 'MM/dd/yyyy'}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[2]?.isChecked">
                {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[2]?.labelname}}:
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{billPrintDetails?.savedBill?.billAmount |
                customNumberFormat: length }}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[4]?.isChecked">
                {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[4]?.labelname}}:
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{billPrintDetails?.savedBill?.openBalance |
                customNumberFormat: length }}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;">
                Bill Status: {{billPrintDetails?.savedBill?.billStatus}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;">
                Received By: {{billPrintDetails?.savedBill?.createdByUser}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_misc  && billTemplate.labels_misc[1]?.isChecked">
                {{billTemplate && billTemplate.labels_misc && billTemplate.labels_misc[1]?.labelname}}:
                {{billPrintDetails?.savedBill?.referenceNo}}
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billPrintDetails?.savedBill && (baseCurrency?.currencyId!==billPrintDetails?.savedBill?.currencyUnitId)">
                Currency: 1
                {{baseCurrency?.code}} = {{billPrintDetails?.savedBill?.exchangeRate}} {{billPrintDetails?.savedBill?.currencyUnit?.code}}</div>



            </td>
            <td style="border-bottom: 1px solid #ddd; border-left: 1px solid #ddd;
                          padding: 9px 0 9px 9px; vertical-align: top; width: 50%;">
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_section  && billTemplate.labels_section[0]?.IsPrint">
                <div>{{billTemplate && billTemplate.labels_section &&
                  billTemplate.labels_section[0]?.labelname}}:{{billPrintDetails?.savedBill?.paymentTerm?.name}}
                </div>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_section  && billTemplate.labels_section[1]?.IsPrint">
                <div>{{billTemplate && billTemplate.labels_section &&
                  billTemplate.labels_section[1]?.labelname}}:{{billPrintDetails?.savedBill?.paymentMethod?.name}}
                </div>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_section  && billTemplate.labels_section[2]?.IsPrint">
                <div>{{billTemplate && billTemplate.labels_section &&
                  billTemplate.labels_section[2]?.labelname}}:{{billPrintDetails?.savedBill?.shippingTerm?.name}}
                </div>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_section  && billTemplate.labels_section[3]?.IsPrint">
                <div>{{billTemplate && billTemplate.labels_section &&
                  billTemplate.labels_section[3]?.labelname}}:{{billPrintDetails?.savedBill?.shippingMethod?.name}}
                </div>
              </div>
              <div style="font-size: 10px;margin-bottom: 2px;"
                *ngIf="billTemplate && billTemplate.labels_section  && billTemplate.labels_section[4]?.IsPrint">
                <div>{{billTemplate && billTemplate.labels_section &&
                  billTemplate.labels_section[4]?.labelname}}:{{billPrintDetails?.savedBill?.userName}}
                </div>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr *ngIf="billPrintDetails?.expenses?.length">
      <td colspan="3" style="padding-top: 15px">
        <table cellpadding="0" cellspacing="0" width="100%">
          <tr>
            <th
              style="font-weight: bold; padding: 5px; text-align: left; background: var(--primary-color); color: white; font-size: 9px"
              *ngIf="billTemplate?.labels_expenses[0]?.IsPrint">
              {{ billTemplate && billTemplate?.labels_expenses && billTemplate?.labels_expenses[0]?.labelname }}
            </th>
            <th
              style="font-weight: bold; padding: 5px; text-align: left; background: var(--primary-color); color: white; font-size: 9px"
              *ngIf="billTemplate?.labels_expenses[2]?.IsPrint">
              {{ billTemplate && billTemplate?.labels_expenses && billTemplate?.labels_expenses[2]?.labelname }}
            </th>
            <th
              style="font-weight: bold; padding: 5px; text-align: left; background: var(--primary-color); color: white; font-size: 9px"
              *ngIf="billTemplate?.labels_expenses[1]?.IsPrint">
              {{ billTemplate && billTemplate?.labels_expenses && billTemplate?.labels_expenses[1]?.labelname }}
            </th>
          </tr>
          <div *ngFor="let product of billPrintDetails?.expenses">
            <tr>
              <td style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 9px"
                *ngIf="billTemplate?.labels_expenses[0]?.IsPrint">{{ product?.financialAccountId?.label }}</td>
              <td style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 9px"
                *ngIf="billTemplate?.labels_expenses[2]?.IsPrint">{{ product?.memo }}</td>
              <td style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 8px; font-size: 9px"
                *ngIf="billTemplate?.labels_expenses[1]?.IsPrint">{{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{
                product?.amount  }}</td>
            </tr>
          </div>
          <tr>    
            <td colspan="2" class="p-text-right" style="font-size: 9px; padding-left: 10px; padding-right: 15px;">Subtotal</td>
            <td style=" font-size: 9px"> {{billPrintDetails?.savedBill?.totalExpenseAmount | multicurrency : (billPrintDetails?.savedBill?.exchangeRate ??
                baseCurrency?.exchangeRate):(billPrintDetails?.savedBill?.currencyUnit?.symbol ?? baseCurrency?.symbol):(length) }}</td>
          </tr>
        </table>
      </td>
    </tr>

    <tr *ngIf="billPrintDetails?.items?.length">
      <td colspan="3" style="padding-top: 20px;">
        <table cellpadding="0" cellspacing="0" width="100%">
          <tr>
            <th style="font-weight: bold; padding: 8px; text-align: left;
                          background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">{{billTemplate
              &&
              billTemplate.labels_table && billTemplate.labels_table[0]?.labelname}}</th>
            <th style="font-weight: bold; padding: 8px; text-align: left;
                          background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">{{billTemplate
              &&
              billTemplate.labels_table && billTemplate.labels_table[1]?.labelname}}</th>
            <th style="font-weight: bold; padding: 8px; text-align: right;
                          background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">{{billTemplate
              &&
              billTemplate.labels_table && billTemplate.labels_table[2]?.labelname}}</th>
            <th style="font-weight: bold; padding: 8px; text-align: right;
                          background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">{{billTemplate
              &&
              billTemplate.labels_table && billTemplate.labels_table[3]?.labelname}}</th>
            <th style="font-weight: bold; padding: 8px; text-align: right;
                          background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate?.labels_table[6]?.IsPrint">
              {{billTemplate && billTemplate.labels_table && billTemplate.labels_table[6]?.labelname}}
            </th>
            <th style="font-weight: bold; padding: 8px; text-align: right;
            background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate?.labels_table[5]?.IsPrint">{{billTemplate
              &&
              billTemplate.labels_table && billTemplate.labels_table[5]?.labelname}}
            </th>
            <th style="font-weight: bold; padding: 8px; text-align: right;
            background: var(--primary-color);color: white;font-size:9px;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">{{billTemplate
              && billTemplate.labels_table &&
              billTemplate.labels_table[4]?.labelname}}
            </th>
          </tr>
          <span *ngFor="let product of billPrintDetails?.items">
            <tr>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
                {{product?.itemNo}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;word-break: break-all;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
                {{product?.description}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
                {{product?.availabel | customNumberFormat: qtyDecimal}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}}{{product?.price}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;font-family: Roboto-Regular;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{product?.cost | customNumberFormat: length }}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;font-family: Roboto-Regular;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[7]?.IsPrint">
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{product?.totalAmount | customNumberFormat:
                length }}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;font-family: Roboto-Regular;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{product?.taxAmount | customNumberFormat: length }}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;font-family: Roboto-Regular;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{product?.lineTotal | customNumberFormat: length }}
              </td>
            </tr>
            <!--Bundle products-->
            <tr *ngFor="let bundle of product.products;let i = index">
              <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;padding-left: 20px;background-color: #f1f1f1;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
                {{bundle?.itemNo}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;word-break: break-all;
                          font-size:9px;padding-left: 20px;background-color: #f1f1f1;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
                {{bundle?.description}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;padding-left: 20px;background-color: #f1f1f1;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
                {{bundle?.availabel}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;padding-left: 20px;background-color: #f1f1f1;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
                {{billPrintDetails?.savedBill?.currencyUnit?.symbol}}{{bundle?.price}}
              </td>
              <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;padding-left: 20px;background-color: #f1f1f1;font-family: Roboto-Regular;"
                *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
                {{bundle?.cost | customNumberFormat: length | currencySymbol}}
              </td>
            </tr>
          </span>
          <tr>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;">Total
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;font-size:9px;background: #e0e0e0;" 
            *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;font-size:9px;background: #e0e0e0;" 
            *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;font-size:9px;background: #e0e0e0;" 
            *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;font-size:9px;background: #e0e0e0;" 
            *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint">
             {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{(billPrintDetails?.savedBill?.totalAmount *
              billPrintDetails?.savedBill?.exchangeRate) | customNumberFormat: length }}
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;background: #e0e0e0;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
              {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{(billPrintDetails?.savedBill?.taxAmount *
                billPrintDetails?.savedBill?.exchangeRate) | customNumberFormat: length }}
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: right;padding:8px;
                          font-size:9px;background: #e0e0e0;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
              {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{(lineTotal) | customNumberFormat: length }}
            </td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 9">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;"
              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
            </td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 8">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint"></td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 7">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
            </td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 6">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint"></td>
           <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint"></td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 5">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
            </td>
             <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
            </td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 4">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint"></td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 3">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;background: #e0e0e0;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
            </td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 2">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint"></td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                          font-size:9px;" 
                          *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint"></td>
          </tr>
          <tr *ngIf="(billPrintDetails?.items.length ) < 1">
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;"
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[0]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;" 
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[1]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;" 
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[2]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;" 
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[3]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;" 
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[6]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;" 
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[5]?.IsPrint">
            </td>
            <td style="border-bottom: 1px solid #e0e0e0;text-align: left;padding:8px;
                                              font-size:9px;background: #e0e0e0;" 
                                              *ngIf="billTemplate && billTemplate.labels_table  && billTemplate.labels_table[4]?.IsPrint">
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr *ngIf="billPrintDetails?.items?.length">
      <td colspan="3">
        <table cellpadding="0" cellspacing="0" style="float: right;page-break-inside: avoid;">
          <tr *ngIf="billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[1]?.IsPrint">
            <th style="text-align: left;padding-right: 29px;text-transform: uppercase;
                          padding:3px;font-weight: bold;min-width: 100px;color: #999;font-size: 10px;">
              {{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[1]?.labelname}}
            </th>
            <td style="text-align: right;padding:3px;font-weight: bold;min-width: 100px;
                          color: #999;font-size: 10px;font-family: Roboto-Regular;">
              {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{(billPrintDetails?.savedBill?.shippingChargeAmount
              *
              billPrintDetails?.savedBill?.exchangeRate) | customNumberFormat: length }}
            </td>
          </tr>
          <tr *ngIf="billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[2]?.IsPrint">
            <th style="text-align: left;padding-right: 29px;text-transform: uppercase;
                          padding:3px;font-weight: bold;min-width: 100px;color: #999;font-size: 10px;">
              {{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[2]?.labelname}}
            </th>
            <td style="text-align: right;padding:3px;font-weight: bold;min-width: 100px;
                          color: #999;font-size: 10px;font-family: Roboto-Regular;">
              {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{billPrintDetails?.savedBill?.discountAmount |
              customNumberFormat: length }}
            </td>
          </tr>
          <tr *ngIf="footerTaxEnabled">
            <th style="text-align: left;padding-right: 29px;text-transform: uppercase;
                          padding:3px;font-weight: bold;min-width: 100px;color: #999;font-size: 10px;">
              {{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[4]?.labelname}}
            </th>
            <td style="text-align: right;padding:3px;font-weight: bold;min-width: 100px;
                          color: #999;font-size: 10px;font-family: Roboto-Regular;">
              {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{billPrintDetails?.savedBill?.taxAmount
                 * billPrintDetails?.savedBill?.exchangeRate |
              customNumberFormat: length }}
            </td>
          </tr>
          <tr *ngIf="billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[3]?.IsPrint">
            <th style="text-align: left;padding-right: 29px;text-transform: uppercase;
                          padding:3px;font-weight: bold;min-width: 100px;color: #999;font-size: 10px;
                          padding-bottom: 6px;">
              {{billTemplate && billTemplate.labels_footer && billTemplate.labels_footer[3]?.labelname}}
            </th>
            <td style="text-align: right;padding:3px;font-weight: bold;min-width: 100px;
                          color: #999;font-size: 10px;padding-bottom: 6px;font-family: Roboto-Regular;">
              {{billPrintDetails?.savedBill?.currencyUnit?.symbol}} {{(billPrintDetails?.savedBill?.netAmount *
                billPrintDetails?.savedBill?.exchangeRate) | customNumberFormat: length }}
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr style="border-top: 4px solid var(--primary-color)"
    *ngIf="showTaxBasedSplitView && taxBasedProductsCols?.length > 0 && taxBasedProductsList?.length > 0">
    <td colspan="3" style="padding-top: 15px">
      <table cellpadding="0" cellspacing="0" width="100%">
        <thead>
          <tr>
            <ng-container *ngFor="let column of taxBasedProductsCols">
              <th
                style="font-weight: bold; padding: 5px; text-align: left; background: var(--primary-color); color: white; font-size: 9px; min-width: 55px">
                {{ column.header }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let product of taxBasedProductsList">
            <tr>
              <ng-container *ngFor="let column of taxBasedProductsCols">
                <td style="border-bottom: 1px solid #e0e0e0; text-align: left; padding: 5px; font-size: 9px">
                  {{ column.field == "itemNo" || column.field == "hsnsac" || column.field == "taxPerc" ?
                  product[column.field] : (product[column.field] | multicurrency: billPrintDetails?.savedBill?.exchangeRate ??
                  baseCurrency?.exchangeRate : billPrintDetails?.savedBill?.currencyUnit?.symbol ?? baseCurrency?.symbol : length) }}
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </td>
  </tr>
    <tr style="border-top: 4px solid var(--primary-color);">
      <td colspan="3">
        <table cellpadding="0" cellspacing="0" width="100%">
          <ng-container *ngIf="billTemplate && billTemplate.labels_message && billTemplate.labels_message[0]?.IsPrint">
            <tr>
              <th style="font-size: 10px;text-align: left;padding-top: 10px;padding-bottom: 3px;padding-left: 9px;">
                {{billTemplate && billTemplate.labels_message && billTemplate.labels_message[0]?.labelname}}:
              </th>
            </tr>
            <tr>
              <td
                style="font-size: 10px;text-align: left;padding-top: 3px;padding-bottom: 3px;padding-left: 9px;word-break: break-all;white-space: normal;"
                [innerHTML]="billPrintDetails?.savedBill?.billOrderNotes?.length > 0 
                  ? billPrintDetails?.savedBill?.billOrderNotes[(billPrintDetails?.savedBill?.billOrderNotes.length - 1)].note.comment 
                  : ''">
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="billTemplate && billTemplate.labels_message && billTemplate.labels_message[1]?.IsPrint">
            <tr>
              <th style="font-size: 10px;text-align: left;padding-top: 10px;padding-bottom: 3px;padding-left: 9px;">
                {{billTemplate && billTemplate.labels_message && billTemplate.labels_message[1]?.labelname}}:
              </th>
            </tr>
            <tr>
              <td style="font-size: 10px;text-align: left;padding-top: 3px;padding-bottom: 3px;padding-left: 9px;
              word-break: break-all;white-space: normal;" class="pdf-img">
                <span [innerHTML]="billPrintDetails?.savedBill?.billOrderNotes?.length>0 ?
                  billPrintDetails?.savedBill?.billOrderNotes[(billPrintDetails?.savedBill?.billOrderNotes.length-1)].note.comment : ''"></span>
              </td>
            </tr>
          </ng-container>

        </table>
      </td>
    </tr>
  </table>
</div>